export const CANCEL_BUTTON_CLASS = "absolute right-4 md:right-5 top-4 md:top-5";
export const MODAL_CONTAINER =
    "flex justify-center items-center  overflow-x-hidden overflow-y-auto fixed inset-0 z-[500] outline-none focus:outline-none";
export const MODAL_SUB_CONTAINER =
    "w-[300px] min-[360px]:w-[343px] md:w-[520px] h-auto  relative  my-6 mx-auto max-w-3xl";
export const MODAL_CONTENT_CONTAINER =
    "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none";
export const MODAL_HEADER =
    "flex flex-col items-center justify-center gap-y-3 md:gap-y-4 mt-4 md:mt-5 pt-4 md:pt-5 rounded-t";
export const MODAL_BODY = "relative   px-4 md:px-10 flex-auto ";
export const MODAL_BODY_TEXT_CLASS = "";
export const MODAL_FOOTER =
    "flex flex-col gap-y-2 md:gap-y-4 pt-4 md:pt-5 pb-7 md:pb-10 rounded-b";
export const BACKGROUND_SHADOW =
    "opacity-75 fixed inset-0 z-50 bg-WHITE_EIGHTY_PERCENT";

export const OTP_CONTAINER = "flex flex-col items-center space-y-4 my-5";

export const GAP = "flex gap-4";

export const OTP_STYLES =
    "font-Montserrat font-medium border-none w-16 h-16 text-center text-2xl font-bold border-2 rounded focus:outline  focus:outline-[#E49DB3] transition-colors ";

export const EXPIRED_STYLES = "flex justify-center items-center";

export const RESEND_STYLES =
    "flex-col md:flex-row flex items-center justify-center";

export const DEFAULT_VALUES = {
    first_name: "",
    last_name: "",
};

export const FIRST_NAME_TEXT = 'First name'

export const FIRST_NAME_FIELD='first_name'

export const LAST_NAME_TEXT = "Last name";

export const LAST_NAME_FIELD = "last_name";
